var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tabs',{staticClass:"phone-preview__tabs",attrs:{"type":"card"},model:{value:(_vm.activeTabId),callback:function ($$v) {_vm.activeTabId=$$v},expression:"activeTabId"}},_vm._l((_vm.tabs),function(tab){return _c('a-tab-pane',{key:tab.id,attrs:{"tab":tab.name}},[[_c(tab.component,{tag:"component",attrs:{"settings":_vm.currentForm}})]],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }